export default "__VITE_ASSET__Dzg1Htkl__"